import React from "react";

import { Typography } from "../Typography";

import type { TypographyProps } from "../Typography";

export function DialogTitle({
  children,
  accessibilityLabel,
  ...props
}: TypographyProps) {
  return (
    <Typography
      variation="semibold.title.three"
      weight="regular"
      color="dialogTextTitle"
      {...props}
      numberOfLines={1}
      focusable={true}
      accessibilityLabel={accessibilityLabel}
    >
      {children}
    </Typography>
  );
}
